export default __webpack_public_path__ + "static/media/1.f0e50b20.png";